import React from 'react';
import LandingApplyForm from '../components/LandingApplyForm';
import logo from '../assets/images/rupya_logo.png';
import './landing-page.css';

const TRUST_ITEMS = [
  { label: 'Paperless', desc: '100% digital' },
  { label: 'Zero Hidden Fees', desc: 'Transparent pricing' },
  { label: 'Quick Disbursal', desc: 'Fast processing' },
  { label: 'NBFC Registered', desc: 'Regulated lender' },
  { label: 'Secure & Encrypted', desc: '256-bit SSL' },
];

const LandingPage = () => (
  <div className="landing-page">
    <div className="landing-hero-wrap">
      <div className="landing-hero-grid-bg" aria-hidden="true" />
      <div className="landing-hero-glow landing-hero-glow--one" aria-hidden="true" />
      <div className="landing-hero-glow landing-hero-glow--two" aria-hidden="true" />

      <div className="landing-hero-inner">
        <div className="landing-hero-content">
          <img src={logo} alt="Mr Rupya" className="landing-brand-logo" />

          <div className="landing-hero-eyebrow">
            <span className="landing-hero-eyebrow-line" />
            Instant Personal Loan Online
          </div>

          <h1>
            Smart Loan Solutions for <span>Every Need</span>
          </h1>

          <p className="landing-hero-desc">
            Empowering your financial future with seamless digital processing,
            instant micro-approvals, and paperless disbursal straight to your bank.
          </p>

          <div className="landing-hero-trust">
            <span>Paperless process</span>
            <span>Quick approval</span>
            <span>Secure &amp; encrypted</span>
          </div>

          <div className="landing-hero-stats">
            <div className="landing-stat-card">
              <small>Available Limit</small>
              <strong>₹1,00,000</strong>
            </div>
            <div className="landing-stat-card">
              <small>Loan Range</small>
              <strong>₹10K – ₹1L</strong>
            </div>
            <div className="landing-stat-card">
              <small>Tenure</small>
              <strong>7 – 365 Days</strong>
            </div>
          </div>
        </div>

        <div className="landing-form-slot">
          <LandingApplyForm />
        </div>
      </div>
    </div>

    <section className="landing-trust-strip" aria-label="Why choose Mr Rupya">
      <p className="landing-trust-heading">Why thousands choose Mr Rupya</p>
      <div className="landing-trust-cards">
        {TRUST_ITEMS.map((item) => (
          <div key={item.label} className="landing-trust-card">
            <strong>{item.label}</strong>
            <span>{item.desc}</span>
          </div>
        ))}
      </div>
    </section>
  </div>
);

export default LandingPage;
